import { v4 as uuidv4 } from 'uuid';
const STORAGE_KEY = 'yc_fallback_device_id';
export function getFallbackDeviceId() {
    let fallbackId = localStorage.getItem(STORAGE_KEY);
    if (!fallbackId) {
        fallbackId = `fallback_${uuidv4()}`;
        localStorage.setItem(STORAGE_KEY, fallbackId);
    }
    return fallbackId;
}
export function clearFallbackDeviceId() {
    localStorage.removeItem(STORAGE_KEY);
}
